"use client"

import React, { useState } from "react"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import toast from "react-hot-toast"

const CreateAdminModal = ({ show, onClose }) => {
  const baseUrl = process.env.REACT_APP_APIURL
  const [token] = React.useState(sessionStorage.getItem("token"))
  const queryClient = useQueryClient()
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    password: "",
    role: "admin",
  })

  const createAdminMutation = useMutation({
    mutationFn: async (data) => {
      return axios.post(`${baseUrl}api/admin/create-admin`, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
    },
    onSuccess: () => {
      toast.success("Admin created successfully!")
      queryClient.invalidateQueries({ queryKey: ["admin-list"] })
      setFormData({ fullname: "", email: "", password: "", role: "admin" })
      onClose()
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Failed to create admin.")
    },
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!formData.fullname || !formData.email || !formData.password) {
      toast.error("All fields are required.")
      return
    }

    createAdminMutation.mutate(formData)
  }

  if (!show) return null

  return (
    <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create New Admin</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={createAdminMutation.isLoading}
            ></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="fullname" className="form-label">
                  Full Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="fullname"
                  name="fullname"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Enter full name"
                  disabled={createAdminMutation.isLoading}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email"
                  disabled={createAdminMutation.isLoading}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  disabled={createAdminMutation.isLoading}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="role" className="form-label">
                  Role
                </label>
                <select
                  className="form-select"
                  id="role"
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  disabled={createAdminMutation.isLoading}
                >
                  <option value="admin">Admin</option>
                  <option value="super-admin">Super Admin</option>
                  <option value="moderator">Moderator</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={createAdminMutation.isLoading}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={createAdminMutation.isLoading}>
                {createAdminMutation.isLoading ? "Creating..." : "Create Admin"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default CreateAdminModal
